"use strict";
/**
 * The play frame on the tap pad (ai/TAP_PAD_PLAN.md): SNAP opens a play, any
 * number of result and yardage taps refine it while it runs (the latest wins),
 * DONE closes it and is the moment a re-post would fire. Pure: state is
 * derived from the tap history every time, so UNDO needs no bookkeeping of its
 * own — undoing DONE reopens the play, undoing SNAP cancels it.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.derivePlay = derivePlay;
exports.decideTap = decideTap;
exports.undoTarget = undoTarget;
exports.tryDue = tryDue;
function derivePlay(history) {
    const undone = new Set(history.filter((t) => t.kind === "undo" && t.undoesTapId).map((t) => t.undoesTapId));
    let open = null;
    let lastSeq = 0;
    for (const t of history) {
        if (t.playSeq !== null)
            lastSeq = Math.max(lastSeq, t.playSeq);
        if (t.kind === "undo" || undone.has(t.tapId))
            continue;
        if (t.kind === "snap")
            open = { seq: t.playSeq ?? lastSeq, taps: [] };
        else if (t.kind === "done")
            open = null;
        else if (open && t.playSeq === open.seq)
            open.taps.push(t);
    }
    return { open, lastSeq, undone };
}
/** Whether a tap of `kind` is taken now, and the play it belongs to. */
function decideTap(kind, state) {
    if (kind === "snap") {
        // Operator's choice (2026-09-24): a forgotten DONE is fixed, not papered over.
        if (state.open)
            return { accept: false, reason: `play ${state.open.seq} still open — tap DONE first` };
        return { accept: true, playSeq: state.lastSeq + 1 };
    }
    if (kind === "done") {
        if (!state.open)
            return { accept: false, reason: "no play open" };
        return { accept: true, playSeq: state.open.seq };
    }
    return { accept: true, playSeq: state.open?.seq ?? null };
}
/** The UNDO's target: the latest tap that is not itself an undo and not yet undone. */
function undoTarget(history, state) {
    return [...history].reverse().find((t) => t.kind !== "undo" && !state.undone.has(t.tapId)) ?? null;
}
const TRY_RESULTS = new Set(["xp_good", "xp_miss", "two_good", "two_fail"]);
/** A live touchdown has no live try result after it: the pad highlights the try row. */
function tryDue(history, state) {
    for (let i = history.length - 1; i >= 0; i--) {
        const t = history[i];
        if (t.kind === "undo" || state.undone.has(t.tapId))
            continue;
        if (TRY_RESULTS.has(t.kind))
            return false;
        if (t.kind === "touchdown")
            return true;
    }
    return false;
}
